// Versión, número de build y commit con los que se construyó esta imagen (PRO-TEC-001 §5.3.3).
// La versión sale del package.json; REACT_APP_BUILD_NUMBER y REACT_APP_COMMIT_SHA los pasa el CI con
// --build-arg al construir la imagen. Sin ellos (desarrollo) queda solo la versión.
import pkg from "../../package.json";

export const APP_VERSION = pkg.version;
export const APP_BUILD = process.env.REACT_APP_BUILD_NUMBER || "";
export const APP_COMMIT = process.env.REACT_APP_COMMIT_SHA || "";

const SHA_CORTO = 7;

// MAYOR.MENOR se sube a mano en package.json; el último número es el del pipeline y sube solo.
// Un build que no sea un entero (argumento sin definir) se ignora en vez de mostrarse.
const conBuild = (base, build) => {
    if (!/^\d+$/.test(build)) return base;
    return `${base.split(".").slice(0, 2).join(".")}.${build}`;
};

export const getAppVersionLabel = ({ version: base = APP_VERSION, build = APP_BUILD, commit = APP_COMMIT } = {}) => {
    const numero = conBuild(base, build);
    if (!commit) return `Versión ${numero}`;
    return `Versión ${numero} · ${commit.slice(0, SHA_CORTO)}`;
};
